import 'datatables.net-dt/css/jquery.dataTables.css';

//import './dataTables.cellEdit.js';

import React, {Component} from 'react';
import swal from 'sweetalert';
import moment from 'moment';
import {translate} from 'react-i18next';
import readXlsxFile from 'read-excel-file';
import {Table} from 'react-bootstrap';
import RaisedButton from 'material-ui/RaisedButton';
import ModalError from '../initial/modalError';
import Help from '../../generics/help';
import {analiticalTestValues, biometricsOption, bloodComponent, healthFacilitiesOption, unitEntriesForUpdate, unitEntriesMultiple} from '../../../libs/services';

const Config = require('../../../config');

const $ = require('jquery');
//$.DataTable = require('datatables.net-dt');
require('../../../assets/dataTables.cellEdit.js');


class UnitsCorrection extends Component{
	constructor(props){
		super(props);

		this.onSearch = this.onSearch.bind(this);
		this.myCallbackFunction = this.myCallbackFunction.bind(this);
		this.onSave = this.onSave.bind(this);
		this.addRow = this.addRow.bind(this);
		this.loadTable = this.loadTable.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.getLectina = this.getLectina.bind(this);

		this.state = {
			listado:[],
			columns:[
				{title:'ORIGEN'},
				{title:'F. DONACIÓN'},
				{title:'NO. UNIDAD'},
				{title:'COMPONENTE'},
				{title:'NO. COMPONENTE'},
				{title:'GRUPO'},
				{title:'RH'},
				{title:'LECTINA'},
				{title:'DU'},
				{title:'VOL'},
				{title:'F. CADUCIDAD'},
				{title:'NOMBRE'},
				{title:'A. PATERNO'},
				{title:'A. MATERNO'},
				{title:'HEMOGLOBINA'},
				{title:'HEMATOCRITO'},
				{title:'OBSERVACIONES'},
				{title:''}
			],
			biometrics:[],
			errores:[],
			lectinas:[],
			du_list:[],
			components:[],
			health_facilities:[],
			health_id:"",
			start_date:"",
			end_date:"",
			data:[],
		}
	}

	async componentDidMount(){
		var response = await healthFacilitiesOption('distribution');
		if(response !== undefined){
			var list = [];
			response.map((res)=>{
				list.push({
					value:res.id,
					display:res.name
				});
			});

			this.setState({
				health_facilities:list,
			});
		}

		this.getLectina('LECTINA');
		
		response = await analiticalTestValues('DU');
		if(response !== undefined && response !== null){
			var du = [];
			du.push({value:'', display:''});
			response.map((d)=>{
				du.push({
					value:d === 'POSITIVO' ? 'POS' : 'NEG',
					display:d === 'POSITIVO' ? 'POS' : 'NEG'
				})
			})
			this.setState({
				du_list:du,
			});
		}
		
		response = await bloodComponent('actives');
		if(response !== undefined){
			var comp = [];
			comp.push({value:'', display:''});
			response.map((c)=>{
				comp.push({
					value:c.component.code,
					display:c.component.code
				})
			})
			this.setState({
				components:comp,
			});
		}

		response = await biometricsOption('biometrics_for_entry_units');
		if(response !== undefined){
			this.setState({biometrics:response});

			response.map((res)=>{
				if(res.name === this.state.columns[14].title){
					this.state.columns[14].title = res.code;
				}

				if(res.name === this.state.columns[15].title){
					this.state.columns[15].title = res.code;
				}

			})

			this.forceUpdate();
		}

		this.loadTable();
	}

	async onSearch(){
		if(this.isValidForm()){			
			var response = await unitEntriesForUpdate(
							this.state.start_date, 
							this.state.end_date, 
							sessionStorage.getItem('health_facilities_id'), 
							this.props.waiting
						);
			if(response !== undefined){
				var list = [], data = [];
						
				response.map((res)=>{
					var health  = '';
					var index = this.state.health_facilities.findIndex(obj => 
						obj.value === res.national_center_origin_id
					);

					if(index !== -1){
						health = this.state.health_facilities[index].display;
					}

					list.push([
						health,
						moment(res.donation_date).format('DD/MM/YYYY'),
						res.unit_number,
						res.component,
						res.component_number,
						res.group,
						res.rh === 'POSITIVO' ? 'POS' : res.rh === 'NEGATIVO' ? 'NEG' : '',
						res.lectina !== null ? res.lectina : '',
						res.du !== null ? res.du : '',
						res.volume,
						res.caducidad !== null ? moment(res.caducidad).format('DD/MM/YYYY') : '',
						res.names,
						res.lastname1,
						res.lastname2,
						res.hgb,
						res.hto,
						res.observations,
						'',
						res.id,
					]);

					data.push([
						res.national_center_origin_id,
						moment(res.donation_date).format('DD/MM/YYYY'),
						res.unit_number,
						res.component,
						res.component_number,
						res.group,
						res.rh === 'POSITIVO' ? 'POS' : res.rh === 'NEGATIVO' ? 'NEG' : '',
						res.lectina !== null ? res.lectina : '',
						res.du !== null ? res.du : '',
						res.volume,
						res.caducidad !== null ? moment(res.caducidad).format('DD/MM/YYYY') : '',
						res.names,
						res.lastname1,
						res.lastname2,
						res.hgb,
						res.hto,
						res.observations,
						''
					])

				});

				this.loadTable();

				this.setState({
					listado: list,
					data: data
				});
			}
		}else{
			swal('Error','Campos Incompletos', 'error');
		}
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    var vacio = false;

	    inputs.forEach(input => {
    		if(input.required){
		      	const isInputValid = this.showCtrlError(input.id);
		      	if (!isInputValid) {
		        	vacio = true;
		    	}
		  	}
	    	
	    });

	    if(vacio){
	    	isFormValid = false;
	    }


	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if(this.state[refName] === undefined){
			if(control !== null){
				if(control.required){
					if(control.value === ""){
						control.classList.add('error');
			        	res = false;
			        	
					}else{
						if(control.className.includes('error')){
							control.classList.remove('error');	
						}
						res = true;
					}
				}
		    }
			
		}else if (this.state[refName] === "") {
	        if(control !== null){
	        	if(control.value === ""){
	           		control.classList.add('error');
	           		res = false;
	           	}else{
	           		if(control.className.includes('error')){
						control.classList.remove('error');
					}
					res = true;
					
	           	}
	        }
			
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
		        	control.classList.remove('error');
		    	}
		    	res = true;
	    	}
			
		}

		return res;
	}

	async getLectina(code){
		var response = await analiticalTestValues(code);
		if(response !== undefined && response !== null && response.length > 0){
			var lect = [];
			lect.push({value:'', display:''});
			response.map((l)=>{
				lect.push({
					value:l,
					display:l
				})
			})
			this.setState({
				lectinas:lect,
			});
		}else{
			if(code !== 'LECTINA'){
				this.getLectina('LECTINA');
			}
		}
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});

		if(e.target.value !== ""){
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	loadTable(){
		setTimeout(()=>{
			this.props.waiting.handleShow('Cargando...');
			this.$el = $(this.el);
		}, 500);

		setTimeout(()=>{
			if(this.$el.attr('class').indexOf('dataTable') !== -1){
				this.$el.DataTable().destroy();
				this.$el.empty();
			}
			this.props.waiting.handleClose();
			this.setTable();
		}, 1000);
	}

	setTable(){
		
		var table = this.$el.DataTable({
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollX: false,
			autoWidth: false,
			info:false,
			ordering:false,
			createdRow: (row, data, dataIndex)=>{
                if(data[17] === "error"){
                	$('td:eq('+(17)+')', row).html(
                		'<i style="color:red;font-size:15px;cursor:pointer" '+
                			'unit_id="'+data[2]+'" class="fas fa-times reg-error" ></i>'
                	);
                }else if(data[17] === "correcto"){
                	$('td:eq('+(17)+')', row).html(
                		'<i style="color:green;font-size:15px" class="fas fa-check reg-correcto"></i>'
                	);
                }else if(data[0] === ''){
                	
                	setTimeout(()=>{
                		if(($('.dataTable tbody tr').length - 1) === dataIndex){
                			/*$('td:eq(0)', row).html(
		                		"<input id='ejbeatycelledit' onfocusout='$(this).updateEditableCell(this)' "+
		                			"value='"+this.state.health_id+"'  style='width:3em;' />"
		                	);*/
                			$('#ejbeatycelledit').focus();
	                		//$('#ejbeatycelledit').parent('td').css({'padding-top':'0'},{'padding-bottom':'0'});
                		}
	                		
                	}, 300)
                }else{
                	$('td:eq('+(data.length - 1)+')', row).html('');
                }
            }
		});

		var errores = this.state.errores;
		$(document).off('click').on('click', '.reg-error', function(){
			var val = $(this).attr('unit_id');

			var index = errores.findIndex(obj =>
				obj.unit_number === val
			);

			if(index !== -1){
				openModal([errores[index]]);
			}
		})

		const openModal = (item)=>{
			this.modal_error.handleShow(item, 'Detalle de error');
		}

		if(this.state.listado.length > 0){
			table.MakeCellsEditable({
		        "onUpdate": this.myCallbackFunction,
		        "inputTypes": [
		        	{
		        		"column":0,
		        		"inputClass":'ini-origen',
		        		"type":"list",
		        		"options":this.state.health_facilities
		        	},
	            	{
		                "column": 1,
		                "type": "date",
	            	},
	            	{
		        		"column":2,
		        		"inputClass":'ini-t-donation',
		        		"type":"span"
		        	},
		        	/*{
		        		"column":2,
		        		"inputClass":'ini-n-unit',
		        		"type":""
		        	},*/
	            	{
	            		"column": 3,
	            		"type": "list",
	            		"options": this.state.components
	            	},
		        	{
		        		"column":4,
		        		"inputClass":'ini-n-comp',
		        		"type":""
		        	},
	            	{
	            		"column": 5,
	            		"type": "list",
	            		"options": [{value:'', display:''},
	            					{value:'A', display:'A'},
	            					{value:'AB', display:'AB'},
	            					{value:'B', display:'B'},
	            					{value:'O', display:'O'}]
	            	},
	            	{
	            		"column": 6,
	            		"type": "list",
	            		"options": [{value:'', display:''},
	            					{value:'POS', display:'POS'},
	            					{value:'NEG', display:'NEG'}]
	            	},
	            	{
	            		"column": 7,
	            		"type": "list",
	            		"options": this.state.lectinas
	            	},
	            	{
	            		"column": 8,
	            		"type": "list",
	            		"options": this.state.du_list
	            	},
		        	{
		        		"column":9,
		        		"inputClass":'ini-vol',
		        		"type":""
		        	},
	            	{
		                "column": 10,
		                "type": "date", 
	            	},
	            	{
		        		"column":14,
		        		"inputClass":'ini-hb',
		        		"type":""
		        	},
		        	{
		        		"column":15,
		        		"inputClass":'ini-hto',
		        		"type":""
		        	},

	        	],
	        	//"inputCss":'form-control',
	        	"columns": [0,1,3,4,5,6,7,8,9,10,11,12,13,14,15, 16],
		    });
		} 
	}

	myCallbackFunction (updatedCell, updatedRow, oldValue) {
		var index = updatedRow.index();

		var item = this.state.listado;
		var updated = updatedRow.data();
		var changed = false;
		
		if(JSON.stringify(item[index]) !== JSON.stringify(this.state.data[index])){
			changed = true;
		}
		setTimeout(()=>{

			item[index] = updated;

			if(changed){
				item[index].push('updated');	
			}

			console.log(item[index])
			this.setState({listado:item});
		}, 500)		
    }

    async onSave(){
    	if(this.validateTable()){
    		var listado = [];

    		this.state.listado.map((l)=>{
    			var donation_date = moment(l[1], 'DD/MM/YYYY');
				var caducidad = moment(l[10], 'DD/MM/YYYY');
				var health = '';
				var index = this.state.health_facilities.findIndex(obj =>
					obj.display === l[0]
				);

				if(index !== -1){
					health = this.state.health_facilities[index].value;
				}

				var updated = l.findIndex(obj => obj === 'updated');

				if(updated !== -1){
					var obj = {
						id:l[18],
	    				health_facilities_id:parseInt(sessionStorage.getItem('health_facilities_id'), 10),
	    				origin_id: health,
	    				donation_date: donation_date.format('MM-DD-YYYY'),
	    				unit_number: l[2],
	    				component:l[3],
	    				component_number:l[4],
	    				group:l[5],
	    				rh:l[6] === 'POS' ? 'POSITIVO' : l[6] === 'NEG' ? 'NEGATIVO' : '',
	    				lectina:l[7],
	    				du:l[8] === 'POS' ? 'POSITIVO' : l[8] === 'NEG' ? 'NEGATIVO' : '',
	    				volume:l[9],
	    				caducidad:caducidad.format('MM-DD-YYYY'),
	    				names:l[11],
	    				lastname1:l[12],
	    				lastname2:l[13],
	    				observations:l[16],
	    				unit_entries_has_biometrics:[]
	    			};
				
					var biometrics = [];
					this.state.biometrics.map((item)=>{
						var bio = this.state.columns.findIndex(obj =>
							obj.title.toUpperCase() === item.code.toUpperCase()
						);
						
						if(bio !== -1){
							biometrics.push({
								biometrics_id: parseInt(item.id, 10),
								value: l[bio],
							});
						}
							
					});

					obj.unit_entries_has_biometrics = biometrics;

					if(l[17] === '' || l[17] === 'error'){
						listado.push(obj);
						l.splice(19, 1);
					}
				}
    		})

			var response = await unitEntriesMultiple(listado, this.props.waiting);
			if(response !== undefined){
				if(response.length > 0){
					this.state.listado.map((list)=>{
						var res = response.findIndex(obj => 
							obj.unit_number === list[2].toString() && obj.component === list[3].toString()
						)

						if(res === -1){
							list[17] = 'correcto';
						}else{
							list[17] = 'error';
						}
					})

					this.setState({errores:response});

					this.loadTable();

				}else{
					swal('Correcto', 'Los datos se cargaron correctamente', 'success');

					this.setState({listado:[]});

					this.loadTable();
				}

			}

    	}
    }

    validateTable(){
    	var requerido = true;
    	var altruista = true;
    	var vacio = false;
    	$('.dataTable tbody tr').each(function(j){
    		$(this).children('td').each(function(i){
    			switch(i){
    				case 0:
    				case 1:
    				case 2:
    				case 4:
    				case 5:
    				case 6: 
    				case 9:
    				case 10:
    				case 11:
    				case 12:
    					if($(this).text() === ''){
    						$(this).addClass('danger');
    						requerido = false;
    					}else if($(this).text() === 'Ningún dato disponible en esta tabla'){
    						vacio = true;
    					}else{
    						$(this).removeClass('danger');
    						
    					}
    					break;
    			}
    		})
			
		})

		if(vacio){
			swal('Error', 'No existen datos por cargar', 'error');
		}else if(!altruista){
    		swal('Error', 'El tipo de donación debe ser unicamente altruista', 'error');
    	}else if(!requerido){
    		swal('Error', 'Campos incompletos', 'error');
    	}else if(requerido && altruista){
			return true;
		}
    }

    addRow(){
    	if(this.state.health_id !== ""){
    		var listado = [];
	    	this.state.columns.map((c, i)=>{
	    		if(i === 3){
	    			listado.push('00');
	    		}else{
	    			listado.push('');
	    		}
	    		
	    	})

	    	this.loadTable();

	    	if(this.state.listado.length > 0){
	    		this.setState({
		    		listado:[...this.state.listado, listado]
		    	});
	    	}else{
	    		this.setState({
		    		listado:[listado]
		    	});
	    	}	   
    	}else{
    		swal('Error', 'Campos incompletos', 'error');
    		document.getElementById('health_id').classList.add('error');
    	}   	 		
    }

    onReturn(){
    	this.props.history.push('/');
    }

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						Carga Inicial
					</h5>
				</div>

				<Help 
					{...this.props}
	                menu={"help_distribution"} 
	                submenu={"help_unit_correction"}  />
	                
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-md-2">
						<span>Fecha Inicial</span>
		                <input type="date" name="start_date" id="start_date" value={this.state.start_date}
		                	className="form-control hour-input" onChange={this.handleChange} required/>
		            </div>
		            <div className="col-xs-12 col-md-2">
						<span>Fecha Final</span>
		                <input type="date" name="end_date" id="end_date" value={this.state.end_date}
		                	className="form-control hour-input" onChange={this.handleChange} required/>
		            </div>

					<div className="col-xs-12 col-sm-2" style={{marginTop:'18px'}}>					
						<button className="btn btn-info" style={{marginLeft:'10px'}} onClick={this.onSearch}>Buscar</button>
					</div>
				</div>

				<div className="col-xs-12" id="table-to-pdf">
					<div >
						<table style={{fontSize:"10px"}} className={"table load-file"} id="table-xls" width="100%" ref={el => this.el = el}>
						</table>
					</div>
				</div>
				<div className="col-xs-12" style={{textAlign:'center'}}>
	        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave}  style={{margin:12}}/>
	        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onReturn}/>
	        	</div>
				
				<ModalError {...this.props} onRef={ref => this.modal_error = ref} />
			</div>
		)
	}
}

export default translate('translations')(UnitsCorrection);